import { JetView } from 'webix-jet';

/**
 * Class representing a filter view for requests.
 * @extends JetView
 */
export default class FilterRequestsView extends JetView {
    /**
     * Configures the layout of the filter requests view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const theme = this.app.config.theme; // Theme configuration

        // Left section containing a date picker
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for date picker
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Center left section containing an ID input
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    type: 'number',
                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'), // Label for ID input
                    labelPosition: 'top',
                    placeholder: _('ID'), // Placeholder text
                },
            ],
        };

        // Center right section containing a department selection
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'Department',
                    label: _('Departamento'), // Label for department selection
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [
                        { id: '0', value: 'Tecnología' },
                        { id: '1', value: 'Soporte' },
                        { id: '2', value: 'Financiero' },
                    ],
                },
            ],
        };

        // Right section containing a state selection
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'State',
                    label: _('Estado'), // Label for state selection
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar'), // Placeholder text
                    options: [
                        { id: '0', value: _('Activo') },
                        { id: '1', value: _('Cerrado') },
                    ],
                },
            ],
        };

        // Upper section containing the filter input fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('requests:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Main form configuration
        return {
            view: 'form',
            id: 'formFilter',
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Apply theme to toolbar
                    elements: [
                        {
                            view: 'label',
                            label: _('Filtrar Tabla'), // Label for the toolbar
                            width: 200,
                        },
                    ],
                },
                upper_section,
                buttons,
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view.
     */
    init() {}
}

// FILE DOCUMENTED
